module.exports = __webpack_public_path__ + "static/media/hard_dollars_7.4a64d761.png";